import axios from "./../../config/axios";

export function getSalesSchedule(id) {
    return axios().get(`/sales-scheduling/schedules/${id}`);
}

export function getSalesSchedules({ start, end, customerIds }) {
    return axios().get(`/sales-scheduling/schedules-search`, { params: { start_at: start, end_at: end, in: customerIds} })
}

export function createSalesSchedule(data) {
    return axios().post(`/sales-scheduling/schedules`, data);
}

export function updateSalesSchedule(data) {
    return axios().put(`/sales-scheduling/schedules/${data.id}`, data);
}

// cales the api to change the dates of the schedule
export function updateSalesScheduleDate(scheduleId, date, remark) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-date`, { new_date: date, remark });
}

// calls the api to change the schedule quantity
export function updateSalesScheduleQuantity(scheduleId, quantity) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-quantity`, { quantity });
}

// calls the api to update the schedule item
export function updateSalesScheduleItem(scheduleId, itemId) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-item`, { item_id: itemId });
}

// calls the api to update schedule state
export function updateSalesScheduleState(scheduleId, state) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-state`, { state_id: state });
}

// calls the api to get a week scheduled quantities
export function getWeekScheduledQuantities() {
    return axios().get(`/sales-scheduling/week-scheduled-quantities`);
}

export function updateSalesScheduleWaitingList(scheduleId, date) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-waiting-list-date`, { date });
}

export function getWaitingList(date) {
    return axios().get(`/sales-scheduling/waiting-list`, { params: { date } });
}

export function updateSalesScheduleCastType(scheduleId, castTypeId) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-cast-type`, { cast_type_id: castTypeId });
}

export function updateSalesSchedulePlant(scheduleId, plantId) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-plant`, { plant_id: plantId });
}

export function updateSalesScheduleSite(scheduleId, siteId) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-site`, { site_id: siteId });
}

export function updateSalesScheduleFloor(scheduleId, floorId) {
    return axios().put(`/sales-scheduling/schedules/${scheduleId}/change-floor`, { floor_id: floorId });
}

export default {
    create: createSalesSchedule,
    find: getSalesSchedule,
    update: updateSalesSchedule,
    changeDate: updateSalesScheduleDate,
    changeQuantity: updateSalesScheduleQuantity,
    changeItem: updateSalesScheduleItem,
    getWeekScheduledQuantities,
    updateSalesScheduleState,
    getWaitingList
}